import SvgMail2 from '~/components/ui/icon/icons/Mail2';
import SvgSms from '~/components/ui/icon/icons/Sms';
import SvgText from '~/components/ui/icon/icons/Text';
import SvgUserRounded from '~/components/ui/icon/icons/UserRounded';
import SvgWhatsappLogo from '~/components/ui/icon/icons/WhatsappLogo';
import SvgWIFI from '~/components/ui/icon/icons/WIFI';
import SvgWorld from '~/components/ui/icon/icons/World';
import { QRCODE_STATIC_TYPE } from '~/constants/qr-code';

export const STATIC_TYPE_LIST = [
  { id: QRCODE_STATIC_TYPE.URL, Icon: SvgWorld },
  { id: QRCODE_STATIC_TYPE.TEXT, Icon: SvgText },
  { id: QRCODE_STATIC_TYPE.WIFI, Icon: SvgWIFI },
  { id: QRCODE_STATIC_TYPE.EMAIL, Icon: SvgMail2 },
  { id: QRCODE_STATIC_TYPE.VCARD, Icon: SvgUserRounded },
  { id: QRCODE_STATIC_TYPE.SMS, Icon: SvgSms },
  { id: QRCODE_STATIC_TYPE.WHATS_APP, Icon: SvgWhatsappLogo },
];
